import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token') || '',
    balance: 0,
    locale: localStorage.getItem('locale') || 'zh',
    sidebarCollapsed: false
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user,
    currentBalance: state => state.balance,
    currentLocale: state => state.locale
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_BALANCE(state, balance) {
      state.balance = balance
    },
    SET_LOCALE(state, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
    },
    SET_SIDEBAR(state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    LOGOUT(state) {
      state.user = null
      state.token = ''
      state.balance = 0
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    }
  },
  actions: {
    login({ commit, dispatch }, { user, token }) {
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      dispatch('refreshBalance')
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    setLocale({ commit }, locale) {
      commit('SET_LOCALE', locale)
    },
    toggleSidebar({ commit, state }) {
      commit('SET_SIDEBAR', !state.sidebarCollapsed)
    },
    async refreshBalance({ commit }) {
      try {
        const { getBalance } = await import('../api')
        const res = await getBalance()
        if (res && res.code === 200 && res.data) {
          commit('SET_BALANCE', parseFloat(res.data.balance))
        }
      } catch (e) {
        console.error('刷新余额失败', e)
      }
    }
  }
})
